import { useRouter } from "next/router";

const useGetPathName = () => {
  const { pathname } = useRouter();
  return pathname;
};

const generateOulipoEventStreamProps = (props) => {
  const {
    content_id,
    content_type,
    recommendation_set_ids,
    search_id,
    parentSlug,
    application,
    count_results_retrieved,
    count_results_total,
    request_type,
    result_identifiers,
    action_name,
    action_prefix,
    component_type,
    current_url,
    raw_query_string,
    layout_index,
  } = props;

  const {
    oulipo_block_id,
    oulipo_page_id,
    oulipo_page_type,
    oulipo_parent_block_id,
    oulipo_response_id,
    oulipo_block_sibling_index,
  } = props;
  const streamEventProps = {
    actionName: "Navigate",
    objectType: "Content",
    streamProperties: {
      content_id,
      content_type,
      oulipo_block_id,
      oulipo_block_sibling_index,
      oulipo_page_id,
      oulipo_page_type,
      oulipo_parent_block_id,
      oulipo_response_id,
      layout_index,
      parent_row: {
        row_slug: parentSlug,
      },
      search_id,
      recommendation_set_ids,
      // eslint-disable-next-line react-hooks/rules-of-hooks
      referrer: useGetPathName(),
      application,
      count_results_retrieved,
      count_results_total,
      request_type,
      result_identifiers,
      action_name,
      action_prefix,
      component_type,
      current_url,
      raw_query_string,
    },
  };
  return streamEventProps;
};

export default generateOulipoEventStreamProps;
